import { render, staticRenderFns } from "./__QuoteList.vue?vue&type=template&id=2f753d6c"
import script from "./__QuoteList.vue?vue&type=script&lang=js"
export * from "./__QuoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports